import id from "./[id].json";
import boardsJson from "./index.json";

const boards = {"pages.boards": boardsJson, "pages.boards.[id]": id};
export {boards};
